import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import ToolsOneTarget from '../components/OptionTarget/TargetToolsOne'

import InformationBox from '../components/InformationBox/InformationBox'


export default function ToolsOne() {
    return (
        <>
            <Container fluid className='gx-0'>
                <Row className='mt-5 gx-0'>
                    <h3 className='spread-font text-dark text-center'>Falabella</h3>
                </Row>
                <Row className='gx-0'>
                    <Col md={9} style={{'overflowY': 'auto', 'height': 'calc(100vh - 200px)'}}>
                        <ToolsOneTarget />
                    </Col>
                    <Col md={3}>
                        <InformationBox />
                    </Col>
                </Row>
               
            </Container>
        </>
    )
}

